import { render, staticRenderFns } from "./MemberCollect.vue?vue&type=template&id=239ed29d&scoped=true&"
import script from "./MemberCollect.vue?vue&type=script&lang=js&"
export * from "./MemberCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ed29d",
  null
  
)

component.options.__file = "MemberCollect.vue"
export default component.exports